export const AFFILIATES_DATA = [
  {
    key: "rclickid",
    expirationDays: 90,
  },
  {
    key: "bid",
    expirationDays: 90,
  },
  {
    key: "mcomid",
    expirationDays: 30,
  },
];

export const AFFILIATES_COOKIES_CLICK_ID = "affiliateClickId";
export const AFFILIATES_COOKIES_CLICK_KEY = "affiliateClickKey";
